import Vue from 'vue'
import { getUrl } from './get-url.js'
import axios from "axios";


export default {
    create: function (user) {
        return Vue.http.post(getUrl('/users'), JSON.stringify(user))
    },

    confirmUser: function (token) {
        return new Promise((resolve, reject) => {
            axios.post(getUrl('/users/register'), {
                token,
            }).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error)
            })
        })
    },

    contactMail: function (params) {
        return new Promise((resolve, reject) => {
            axios.post(getUrl('/users/contact'), {
                lastName: params.lastName,
                firstName: params.firstName,
                email: params.email,
                description: params.description,
            }).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },

    getToken: function (params) {
        return Vue.http.get(getUrl('/users/verifyUrlToken/' + params.token));
    },

    getNames: function(token) {
        return Vue.http.get(getUrl('/users/getNames/' + token));
    },

    editNames: function(params) {
        return new Promise((resolve, reject) => {
            axios.post(getUrl('/users/editNames'), {
                id: params.id,
                nom: params.nom,
                prenom: params.prenom,
                civilite: params.civilite,
            }).then(response => {
                resolve(response);
            }).catch( error => {
                reject(error);
            })
        })
    },

    sendPdf: function(params) {
        return new Promise((resolve, reject) => {
            axios.post(getUrl('/users/sendPdf'), {
                nom: params.nom,
                prenom: params.prenom,
                civilite: params.civilite,
            }, {
                responseType: 'blob'
            }).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            })
        })
    },
}



// WEBPACK FOOTER //
// ./src/services/users.js